import { render } from "./ExpanderCountdown.vue?vue&type=template&id=374d588c&scoped=true"
import script from "./ExpanderCountdown.vue?vue&type=script&lang=js"
export * from "./ExpanderCountdown.vue?vue&type=script&lang=js"

import "./ExpanderCountdown.vue?vue&type=style&index=0&id=374d588c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374d588c"]])

export default __exports__